module.exports = __webpack_public_path__ + "static/media/haiwaishenbaoliucheng2.ea3513bb.png";